import React from "react"
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {withFormik} from 'formik';
import {FormattedMessage, injectIntl} from "react-intl";
import {displayErrors, parsePropertiesErrors} from "../../../form-helpers";
import {handleApiResponse} from "../../../crud-actions";
import {downloadDocument} from "../../../../../idoa/app/actions/download";
import ContentShow from "../../content-editor/content-show";
import AttachmentsList from "../attachments-list";
import ContentUnitHeader from "../content-unit-header";
import BaseComponent from "../../base-component";

class Select extends React.Component {
    render() {
        const { color = 'primary', disabled = false, value, setFieldValue, handleBlur, id, count = 5  } = this.props;

        let items = [];
        for(let i = 1; i <= count; i++) {
            items.push((
                <div className='custom-control custom-radio' key={i}>
                    <input id={`${id}_${i}`} name={id} type="radio" disabled={disabled} className='custom-control-input' value={null} checked={value === i.toString()} onChange={() => { setFieldValue(id, i.toString()) }} onBlur={handleBlur}/>{' '}
                    <label className="custom-control-label" htmlFor={`${id}_${i}`}><FormattedMessage id={`app.new_employee_feedback_form.btn_group_select.${i}`}/></label>
                </div>
            ))
        }

        return (
            <div className='mb-3'>
                { items }
            </div>
        );
    }
}

class InnerForm extends BaseComponent {

    render() {
        const { intl, values, touched, errors, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue, isComplete } = this.props;
        return (
            <form onSubmit={handleSubmit}>
                <p><FormattedMessage id='app.personal_forms.message.required_fields'/> (<span className='text-red'>*</span>)</p>
                <hr/>
                { displayErrors(errors, 'base') }

                <div className='form-group'>
                    <FormattedMessage id='app.new_employee_feedback_form.feedback_field_1'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage>
                    <Select id='data.feedback_field_1' value={values.data.feedback_field_1} disabled={isComplete} setFieldValue={setFieldValue} handleBlur={handleBlur}/>
                    { displayErrors(errors, 'data.feedback_field_1') }
                </div>

                <div className='form-group'>
                    <FormattedMessage id='app.new_employee_feedback_form.feedback_field_2'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage>
                    <Select id='data.feedback_field_2' value={values.data.feedback_field_2} disabled={isComplete} setFieldValue={setFieldValue} handleBlur={handleBlur}/>
                    { displayErrors(errors, 'data.feedback_field_2') }
                </div>

                <div className='form-group'>
                    <FormattedMessage id='app.new_employee_feedback_form.feedback_field_3'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                    <textarea disabled={isComplete} rows="4" value={values.data.feedback_field_3} id='data.feedback_field_3' className='form-control' onChange={handleChange} onBlur={handleBlur}/>
                    { displayErrors(errors, 'data.feedback_field_3') }
                </div>

                <div className='form-group'>
                    <FormattedMessage id='app.new_employee_feedback_form.feedback_field_4'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage>
                    <Select id='data.feedback_field_4' count={6} value={values.data.feedback_field_4} disabled={isComplete} setFieldValue={setFieldValue} handleBlur={handleBlur}/>
                    { displayErrors(errors, 'data.feedback_field_4') }
                </div>

                <div className='form-group'>
                    <FormattedMessage id='app.new_employee_feedback_form.feedback_field_5'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                    <textarea disabled={isComplete} rows="4" value={values.data.feedback_field_5} id='data.feedback_field_5' className='form-control' onChange={handleChange} onBlur={handleBlur}/>
                    { displayErrors(errors, 'data.feedback_field_5') }
                </div>

                <div className='form-group'>
                    <FormattedMessage id='app.new_employee_feedback_form.feedback_field_6'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                    <textarea disabled={isComplete} rows="4" value={values.data.feedback_field_6} id='data.feedback_field_6' className='form-control' onChange={handleChange} onBlur={handleBlur}/>
                    { displayErrors(errors, 'data.feedback_field_6') }
                </div>

                <div className='form-group'>
                    <FormattedMessage id='app.new_employee_feedback_form.feedback_field_7'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage>
                    <Select id='data.feedback_field_7' count={6} value={values.data.feedback_field_7} disabled={isComplete} setFieldValue={setFieldValue} handleBlur={handleBlur}/>
                    { displayErrors(errors, 'data.feedback_field_7') }
                </div>

                <div className='form-group'>
                    <FormattedMessage id='app.new_employee_feedback_form.feedback_field_8'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage>
                    <Select id='data.feedback_field_8' count={6} value={values.data.feedback_field_8} disabled={isComplete} setFieldValue={setFieldValue} handleBlur={handleBlur}/>
                    { displayErrors(errors, 'data.feedback_field_8') }
                </div>

                <div className='form-group'>
                    <FormattedMessage id='app.new_employee_feedback_form.feedback_field_9'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                    <textarea disabled={isComplete} rows="4" value={values.data.feedback_field_9} id='data.feedback_field_9' className='form-control' onChange={handleChange} onBlur={handleBlur}/>
                    { displayErrors(errors, 'data.feedback_field_9') }
                </div>

                { !isComplete && <button type='submit' className='btn btn-primary' disabled={isSubmitting}>{intl.formatMessage({id: 'app.actions.save'})}{this.spinner(isSubmitting)}</button> }
            </form>
        )
    }
}

InnerForm = injectIntl(withFormik({
    enableReinitialize: true,
    mapPropsToValues: (props) => {
        if (props.resource.employee_data) return props.resource.employee_data;

        return {
            data: {
                feedback_field_1: '',
                feedback_field_2: '',
                feedback_field_3: '',
                feedback_field_4: '',
                feedback_field_5: '',
                feedback_field_6: '',
                feedback_field_7: '',
                feedback_field_8: '',
                feedback_field_9: '',
            }
        }
    },
    handleSubmit: (values, form) => { form.props.submit(values, form); },
    displayName: 'NewEmployeeFeedbackFormInner',
})(InnerForm));

class NewEmployeeFeedbackForm extends React.Component {

    sendForm = (values, form) => {
        let promise = this.props.assignmentUpload('api/v1', this.props.assignment.id, 'submit_form', values.data);
        handleApiResponse('ASSIGNMENT', 'ACTION', promise,
            (result) => {
                this.props.push('/');
                this.props.setNotification('success', this.props.intl.formatMessage({id: 'app.new_employee_feedback_form.message.submit.success'}));
            },
            (result) => {
                this.props.setNotification('warning', this.props.intl.formatMessage({id: 'app.new_employee_feedback_form.message.submit.fail'}));
                let errors = result.payload.response.errors;
                errors = parsePropertiesErrors(errors, 'data');
                form.setErrors(errors);
            },
            (error) => {
                this.props.setNotification('danger', this.props.intl.formatMessage({id: 'app.message.unknown_error'}));
                console.log(error);
            }).then(() => {
            form.setSubmitting(false);
        });
    };

    render() {
        const { assignment } = this.props;
        const contentUnit = assignment.content_unit;
        const isComplete = assignment.state === 'complete';

        return (
            <div>
                <ContentUnitHeader contentUnit={contentUnit}/>
                <div className='container'>
                    <ContentShow contentData={contentUnit.content}/>
                    <hr/>
                    <InnerForm resource={assignment} submit={this.sendForm} isComplete={isComplete}/>
                    <AttachmentsList contentUnit={contentUnit}/>
                </div>
            </div>
        )
    };
}

function mapStateToProps(state,ownProps) {
    return {
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        downloadDocument: downloadDocument,
    }, dispatch);
}

export default injectIntl(connect(mapStateToProps, matchDispatchToProps)(NewEmployeeFeedbackForm));
